/* eslint-disable import/no-cycle */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface UserSelectListPayload {
    searchWord?: string;
    loginId?: string;
    userFamilyName?: string;
    userName?: string;
    pageNo?: number;
    pageSize?: number;
}

export interface User {
    check?: string;
    loginId: string;
    userFamilyName: string;
    userName: string;
    userId?: string;
    name?: string;
    orgPath?: string;
    returnOrgPath: string;
    homePhone?: string;
    mainMail?: string;
    subMail?: string;
    titleName?: string;
}

export interface UserList {
    userList: User[];
}

class UserSelectListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "userSelectList");
    }

    public async findAll(payload: UserSelectListPayload, resolved: (userList: UserList) => void, rejected: (error: any) => void) {
        await super.postJSON(
            payload,
            (json: any) => {
                const userList = json as UserList;
                resolved(userList);
            },
            rejected
        );
    }

    public async find(loginId: string, resolved: (user: User) => void, rejected: (error: any) => void) {
        await this.findAll(
            { loginId },
            (userList: UserList) => {
                const _user = userList.userList.find((e: User) => e.loginId === loginId);
                if (!_user) {
                    const message = `ログインID[${loginId}]に該当するユーザが存在しません。`;
                    console.error(message);
                    throw Error(message);
                }
                resolved(_user);
            },
            rejected
        );
    }
}

export default UserSelectListService;
